import React, { Component } from "react";
import Select, {
  SingleValue,
  StylesConfig,
  components,
  MenuProps,
} from "react-select";
import styles from "./styles.module.sass";

interface Option {
  value: string | number;
  label: string | number;
}

interface DropdownProps {
  options: Option[];
  onChange: (selectedOption: Option) => void;
  value?: Option;
}

interface DropdownState {
  selectedOption: Option;
}

// Custom Menu component with header
const Menu = (props: MenuProps<Option, false, never>) => {
  return (
    <components.Menu<Option, false, never> {...props}>
      {props.children}
    </components.Menu>
  );
};

class Dropdown extends Component<DropdownProps, DropdownState> {
  constructor(props: DropdownProps) {
    super(props);
    this.state = {
      selectedOption: props.value ?? props.options[0],
    };
  }

  componentDidUpdate(prevProps: DropdownProps) {
    if (prevProps.value !== this.props.value && this.props.value) {
      this.setState({ selectedOption: this.props.value });
    }
  }

  handleChange = (selectedOption: SingleValue<Option>) => {
    if (selectedOption) {
      this.setState({ selectedOption });
      this.props.onChange(selectedOption);
    }
  };

  render() {
    const { options } = this.props;
    const { selectedOption } = this.state;

    const customStyles: StylesConfig<Option, false, never> = {
      control: (provided, state) => ({
        ...provided,
        cursor: "pointer",
        border: "1px solid #ccc",
        borderRadius: 5,
        boxShadow: state.isFocused ? "0 0 0 0px #000" : "none",
        "&:hover": {
          border: "1px solid #ccc",
          boxShadow: "0 1px 0 0px #ccc",
        },
      }),
      menu: (provided) => ({
        ...provided,
        borderRadius: 0,
        boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
        margin: 0
      }),
      menuList: (provided) => ({
        ...provided,
        padding: 0,
      }),
      option: (provided, state) => ({
        ...provided,
        backgroundColor: state.isSelected
          ? "#000"
          : state.isFocused
          ? "#f0f0f0"
          : "#fff",
        color: state.isSelected ? "#fff" : "#000",
        cursor: "pointer",
        padding: "8px 12px",
        textAlign: "center",
        "&:hover": {
          backgroundColor: "#000",
          color: "#fff",
        },
      }),
      singleValue: (provided) => ({
        ...provided,
        color: "#000",
      }),
      dropdownIndicator: (provided) => ({
        ...provided,
        color: "#000",
        "&:hover": {
          color: "#666",
        },
      }),
      indicatorSeparator: () => ({ display: "none" }),
    };

    return (
      <div className={styles.dropdownWrapper}>
        <Select
          className={styles.dropdown}
          classNamePrefix="custom-select"
          name="form-field-name"
          value={selectedOption}
          onChange={this.handleChange}
          options={options}
          isClearable={false}
          isSearchable={false}
          styles={customStyles}
          components={{ Menu }}
        />
      </div>
    );
  }
}

export default Dropdown;
